__webpack_require__.p = "/hand_recognition_math_calculations/";